import React from "react"
import hero0 from "../../asserts/hero0.png"
import hero1 from "../../asserts/hero1.png"
import hero2 from "../../asserts/hero2.png"
import { Outlet } from "react-router-dom"

const Home = () => {
  return (
    <>
      <div className="w-screen sm:w-full h- screen">
        <div className="flex flex-col p-3 overflow-y-hidden bg -primary" id="image-container">
          <div className="flex w-full h-full md:justify-center justify-start flex-col overflow-hidden">
            <div className="flex justify-center md:space-x-2">
              <img
                src={hero1}
                alt="hero"
                className="h-[35rem] w-1/3 md:flex hidden"
              />
              <img src={hero0} alt="hero" className="md:h-[35rem]" />
              <img
                src={hero2}
                alt="hero"
                className="h-[35rem] w-1/3 md:flex hidden"
              />
            </div>
            <div className="flex w-full justify-center text-center">
              <span className="md:text-3xl uppercase text-2xl font-bold shadow-lg shadow-secondary bg-white md:w-[26.5rem] w-[21rem] py-2 -mt-5">
                You heard it from me.
              </span>
            </div>
          </div>
        </div>
        <div className="h-full overflow-auto">
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default Home
